module.exports = __webpack_public_path__ + "images/qrcode-ios-58bf3c7dc02362538f1195cf60ec2f64.png";